import type { ApartmentGalleryImageItem } from '@/lib/apartments/apartmentGallery'
import { cn } from '@/utilities/ui'

type RoomGalleryImageSlideProps = {
  className?: string
  item: ApartmentGalleryImageItem
  objectFit?: 'cover' | 'contain'
}

export function RoomGalleryImageSlide({
  className,
  item,
  objectFit = 'cover',
}: RoomGalleryImageSlideProps) {
  const fitClassName = objectFit === 'contain' ? 'object-contain' : 'object-cover'

  return (
    <div className={cn('relative size-full bg-black/10', className)}>
      {/* Payload image URLs are served by the local media route; keep the native image
          here so Embla can size every slide immediately. */}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        alt={item.alt}
        className={cn('block size-full object-center', fitClassName)}
        height={item.height ?? 900}
        src={item.src}
        width={item.width ?? 1440}
      />
    </div>
  )
}
